import { TransaksiFarmasiItem } from "@/types/obat_farmasi";

type ItemTransaksi = TransaksiFarmasiItem["items"][number];

function teks(nilai: any): string {
  return nilai === null || nilai === undefined ? "" : String(nilai);
}

function aturanPakai(sumber: any) {
  const nama = teks(
    sumber && sumber.aturan_pakai ? sumber.aturan_pakai.nama : ""
  ).trim();

  if (!nama) return null;

  return {
    id: teks(sumber.aturan_pakai.id),
    nama
  };
}

function itemDariResepItem(item: any): ItemTransaksi {
  return {
    kode: teks(item.obat_id),
    nama: teks(item.obat_nama),
    jenis: "obat",
    satuan: teks(item.qty_unit),
    qty: item.qty,
    kategori: "non-racikan",
    harga: item.harga,
    aturan_pakai: aturanPakai(item)
  };
}

function itemDariRacikan(racikan: any, resepId: any, urutan: number): ItemTransaksi {
  const isi = (racikan.items || [])
    .map(function(it) {
      return teks(it.obat_nama);
    })
    .filter(function(nama) {
      return !!nama;
    })
    .join(" + ");

  const nama = teks(racikan.nama).trim() || isi || "Racikan";

  return {
    kode: "racikan-" + teks(resepId) + "-" + teks(racikan.r || urutan),
    nama: isi && teks(racikan.nama).trim() ? nama + " (" + isi + ")" : nama,
    jenis: "obat",
    satuan: "",
    qty: racikan.qty,
    kategori: "racikan",
    harga: null,
    aturan_pakai: aturanPakai(racikan)
  };
}

function itemDariText(text: string, resepId: any): ItemTransaksi[] {
  const isi = teks(text).replace(/\r/g, "");

  if (!isi.trim()) return [];

  const blok = /R\//.test(isi)
    ? isi
        .split(/^(?=\s*R\/)/m)
        .map(function(b) {
          return b.replace(/\s+/g, " ").trim();
        })
    : isi.split("\n").map(function(b) {
        return b.replace(/\s+/g, " ").trim();
      });

  return blok
    .filter(function(b) {
      return !!b;
    })
    .map(function(b, idx): ItemTransaksi {
      return {
        kode: "text-" + teks(resepId) + "-" + idx,
        nama: b,
        jenis: "obat",
        satuan: "",
        qty: "",
        kategori: "non-racikan",
        harga: null,
        aturan_pakai: null
      };
    });
}

function transaksiDariResepObat(list: Array<any>): TransaksiFarmasiItem[] {
  return (list || [])
    .filter(function(resep) {
      return resep && !resep.deleted_at;
    })
    .map(function(resep): TransaksiFarmasiItem {
      const items = (resep.items || [])
        .filter(function(it) {
          return it && !it.stopped_at;
        })
        .map(itemDariResepItem);

      const racikan = (resep.resep_racikan || [])
        .filter(function(rc) {
          return rc && !rc.stopped_at;
        })
        .map(function(rc, idx) {
          return itemDariRacikan(rc, resep.id, idx);
        });

      const terstruktur = items.concat(racikan);

      return {
        no_trans: teks(resep.nomor) || "resep-" + teks(resep.id),
        tgl_trans: teks(resep.tanggal),
        jenis_resep: teks(resep.jenis_resep),
        unit: resep.unit || { id: "", nama: "" },
        dokter: resep.dokter || { id: "", c_doc_id: "", nama: "" },
        kd_depo: teks(resep.depo_id),
        items: terstruktur.length
          ? terstruktur
          : itemDariText(resep.text, resep.id)
      };
    })
    .filter(function(trx) {
      return trx.items.length > 0;
    });
}

export { transaksiDariResepObat };
